import { chartFontStyle } from '../../../src/composables/helper/static-options'
import { YAXIS_POSITION } from '../../../src/constants/chart-related.constant'
import { IChartOptions } from '../../../src/types/chart-options.type'
import { yAxisFormatter } from '../../../src/utils/formatter.util'

export const getYAxisOptions = (chartOptions: IChartOptions) => {
  return [
    {
      title: {
        text: chartOptions.yAxisOptions.left.title,
        style: { color: 'rgba(var(--bc-dark), var(--o04))', fontSize:'12px', textOverflow: 'ellipsis' },
      },
      type: chartOptions.yAxisOptions.left.type,
      tickAmount: 7,
      opposite: false,
      softMin: chartOptions.yAxisOptions.left.softMin,
      max: chartOptions.yAxisOptions.left.max,
      labels: {
        formatter: yAxisFormatter(chartOptions.yAxisOptions.left),
        style: chartFontStyle,
        align: 'right',
      },
      startOnTick: false,
      showFirstLabel: true,
      showLastLabel: true,
      gridLineColor: 'rgba(var(--bc-gray), var(--o02))',
      reversedStacks: false,
      visible: chartOptions.chartDataList.find(ele=> ele.yAxis === YAXIS_POSITION.LEFT) !== undefined,
    },
    {
      title: {
        text: chartOptions.yAxisOptions.right.title,
        style: { color: 'rgba(var(--bc-dark), var(--o04))', fontSize:'12px', textOverflow: 'ellipsis' },
      },
      type: chartOptions.yAxisOptions.right.type,
      tickAmount: 7,
      opposite: true,
      softMin: chartOptions.yAxisOptions.right.softMin,
      max: chartOptions.yAxisOptions.right.max,
      labels: {
        formatter: yAxisFormatter(chartOptions.yAxisOptions.right),
        style: chartFontStyle,
        align: 'left',
      },
      startOnTick: false,
      showFirstLabel: true,
      showLastLabel: true,
      gridLineColor: 'rgba(var(--bc-gray), var(--o02))',
      reversedStacks: false,
    },
  ]
}